import { createI18n } from 'vue-i18n';
import en from './lang/en.json';
import de from './lang/de.json';

const i18n = createI18n({
  legacy: false,
  locale: ['en', 'de'].includes(localStorage.getItem('lang'))
    ? localStorage.getItem('lang')
    : 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    de
  }
});

export default i18n;
